'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'cloud-rainbow';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f73e';
var svgPathData = 'M552 240c-23.5 0-45.3 7.2-63.4 19.6-8.5-5-17.5-9.1-27-12.3-1.5-7.8-3.8-15.4-6.6-22.6 26.9-20.5 60.5-32.8 97-32.8l24 0 0 48-24 0zm0-96c-46 0-88.5 14.9-122.9 40.2-11.5-12.2-25.3-22.1-40.8-29 44.4-36.9 101.4-59.2 163.7-59.2l24 0 0 48-24 0zm0-96c-87.5 0-166.4 37-221.8 96.1-16.1 .7-31.4 4.4-45.4 10.5-4.9-4.5-10-8.7-15.4-12.6 64.2-86.2 166.9-142.1 282.6-142.1l24 0 0 48-24 0zM96 480l-96 0 0-96c0-41.8 26.7-77.4 64-90.5L64 272c0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-416 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;